export enum PaymentMethodEnumFR {
  CB = 'CB',
  CHEQUE = 'CHEQUE',
  VIREMENT_PEA = 'VIREMENT_PEA',
  WALLET = 'WALLET',
}

export enum PaymentMethodEnum {
  WALLET = 'WALLET',
  CREDIT_CARD = 'CREDIT_CARD',
  TRANSFER_PEA = 'TRANSFER_PEA',
  CHEQUE = 'CHEQUE',
}

export const translatePaymentMethod = (pm: PaymentMethodEnumFR): PaymentMethodEnum => {
  switch (pm) {
    case PaymentMethodEnumFR.CB:
      return PaymentMethodEnum.CREDIT_CARD;
    case PaymentMethodEnumFR.CHEQUE:
      return PaymentMethodEnum.CHEQUE;
    case PaymentMethodEnumFR.VIREMENT_PEA:
      return PaymentMethodEnum.TRANSFER_PEA;
    case PaymentMethodEnumFR.WALLET:
      return PaymentMethodEnum.WALLET;
  }
};
